import { format, Locale, parseISO } from "date-fns";
import { es, de, it, pt, ro, enGB, cs, tr, nl } from "date-fns/locale";

import { Opco } from "types/Opco";

const opcoToLocale: Record<string, Locale> = {
  es,
  de,
  it,
  pt,
  ro,
  tr,
  gb: enGB,
  cz: cs,
  nl,
  lw: es,
};

const defaultLocale = enGB;

const opcoToDateFormat: Partial<Record<Partial<Opco>, string>> = {
  es: "d MMMM, yyyy",
  lw: "d MMMM, yyyy",
  pt: "d MMMM, yyyy",
  de: "d. MMMM yyyy",
  ro: "d MMMM yyyy",
  cz: "d MMMM yyyy",
  tr: "d MMMM yyyy",
  gb: "MMMM dd, yyyy",
  nl: "d MMMM yyyy",
};

const defaultDateFormat = "MMMM d, yyyy";

const composeEndDate = (endDate: Date | string | null, opco: Opco): string => {
  if (!endDate) return "";

  const date = format(parseISO(endDate as string), opcoToDateFormat[opco] ?? defaultDateFormat, {
    locale: opcoToLocale[opco] ?? defaultLocale,
  });

  return date;
};

export default composeEndDate;
